var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineICon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9774 11.7802H11.3443L7.22493 7.54155L2.97709 11.7802H0.408203L5.9619 5.6791L0.772129 0.220215H3.44806L7.26775 3.83807L11.1303 0.220215H13.6563L8.53079 5.6791L13.9774 11.7802Z",
    fill: "#FF6062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineICon);
export default __webpack_public_path__ + "static/media/DeclineICon.613056e0ae08deba0379880d2c79410e.svg";
export { ForwardRef as ReactComponent };